<template>
<div>
 <div class="row no-margin">
  <div class="col no-padding">
    <h2 class="sub-title">INVOICE </h2>

    <div class="summary-panel pdfnone">
    <div class="panel-grid">
      <ul class="panel-grid-list">
        <li>
          <div class="panel-grid-list-header">INVOICE ID</div>
          <div class="plstyle">
           <div class="panel-grid-list-text"> {{invoice.invoice_number}}</div>
          </div>
        </li>
      </ul>
    </div>
    </div>

<div class="bottomfixed pdfnone">
    <h2 class="sub-title">E- SIGNATURE</h2>
   <div class="signature-field">
     <div class="sigbox">
    </div>
   </div>
 </div>

   <!-- <div class="signature-content">
    <div class="row content-list">
     <div class="col-5 content-list-title">Date</div>
     <div class="col-6 content-list-label">02/15/2019</div>
    </div>
    <div class="row content-list">
     <div class="col-5 content-list-title">Name</div>
     <div class="col-6 content-list-label">Vidya Acharya</div>
    </div>
    <div class="row content-list">
     <div class="col-5 content-list-title">Time</div>
     <div class="col-6 content-list-label">05:29PM</div>
    </div>
    <div class="row content-list">
     <div class="col-5 content-list-title">Location</div>
     <div class="col-6 content-list-label">Chennai</div>
    </div>
    <div class="row content-list">
     <div class="col-5 content-list-title">IP Address</div>
     <div class="col-6 content-list-label">192.0.0.0/24</div>
    </div>
    <div class="row content-list">
     <div class="col-5 content-list-title">Phone Number</div>
     <div class="col-6 content-list-label">99807 77653</div>
    </div>
   </div> -->
  </div>

  <div class="col-5 bg-sign">
    <div class="signature-totalcontent">
     <div class="row content-list lh" v-if="this.invoice.order_payments.length">
      <div class="col-4 content-list-title no-padding">Total</div>
      <div class="col content-list-total">{{ decimalPoint(indentsTotal) }}</div>
     </div>

     <div class="row content-list lh"
     v-for="discount in discountList"
     v-bind:key="discount._id">
      <div class="col-4 content-list-title no-padding">{{discount.label || '-'}}</div>
      <div class="col content-list-label">{{discount.percentage}} %</div>
      <div class="col content-list-total">{{ decimalPoint(discount.amount) }}</div>
     </div>

     <div class="row content-list lh" v-if="invoice.wallet_ids.length">
      <div class="col-4 content-list-title no-padding">Wallet</div>
      <div class="col-5 content-list-label mrg10">
        <div class="dropdown-section">
        <!-- <Select v-model="value4" placeholder="Select">
            <Option
              v-for="item in wallet"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </Option>
          </Select> -->
        </div>
        <div class="action">
      <Popover placement="bottom-end" popper-class="newpopover tablepadding" v-model="penalties">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>PENALTIES</h3>
            <span class="remove-icon" @click="penalties=false">
              <svgicon name="cancelblack" width="12" height="12" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body">
             <!-- <div v-for="(wallet, idx) in invoice.wallet_ids" :key="idx">
                {{wallet.order_number}} - {{getType(wallet.type)}} - {{wallet.amount}}
              </div> -->

              <div class="tablepanel">
              <div class="new">
                <div class="table">
                  <div class="table-header">
                  <div class="table-row">
                    <div class="table-th w200">REASON</div>
                    <div class="table-th w150">INDENT ID</div>
                    <div class="table-th table-td-right w100">AMOUNT</div>
                  </div>
                </div>
                <div class="table-bgcolor scrolltable">
                <div class="table-row table-rowbg" v-for="(wallet, idx) in invoice.wallet_ids" :key="idx">
                  <div class="table-td w200">{{getType(wallet.type)}}</div>
                  <div class="table-td w150">{{(wallet.order_id && wallet.order_id.order_no)}}</div>
                  <div class="table-td table-td-right w100">{{wallet.amount}}</div>
                </div>
              </div>
              </div>
              </div>
              </div>

          </div>
        </div>
        <div slot="reference">
          <div class="nmrg10">
          {{invoice.wallet_ids.length}} Penalties applied
          <div class="notificationicon">
          <svgicon name="info-black" width="12" height="12" :original="true" />
        </div>
      </div>
        </div>
      </Popover>
    </div>
      </div>
      <!-- <div class="col content-list-total">{{walletTotal}}</div> -->
     </div>


     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">Service recepient state</div>
      <div class="col-5 content-list-label ">
        <div class="dropdown-section mrg10">
        {{extractTax.source || '-'}}
        </div>
      </div>
     </div>
     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">Service provider state </div>
      <div class="col-5 content-list-label">
        <div class="dropdown-section mrg10">
        {{extractTax.destination || '-'}}
        </div>
      </div>
     </div>
     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">GST Method </div>
      <div class="col-6 content-list-label">
        <div class="dropdown-section mrg10">
         {{(invoice.gst_type === 2) ? 'Reverse' : 'Forward' }} Charge Mechanism
        </div>
      </div>
     </div>
     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">GSTIN</div>
      <div class="col content-list-label">
        {{(invoice.gst_number) ? invoice.gst_number : '--'}}
      </div>
     </div>

     <div class="row content-list lh hr" v-if="invoice.gst_type === 1">
       <div class="col-4 content-list-title no-padding">Tax</div>
       <div class="col content-list-label" v-if="extractTax.same_state === 1">
         <div class="lhn">CGST {{extractTax.cgst}}% {{ decimalPoint(total_central_tax) }}</div>
         <div class="lhn">{{ ($hasFeature('ugst_support') && extractTax.intra_state && isUgstApplicable(extractTax.destination)) ? 'UGST' : 'SGST' }} {{extractTax.sgst}}% {{ decimalPoint(total_state_tax) }}</div>
       </div>
       <div class="col content-list-label" v-else>
         <div class="lhn">IGST {{extractTax.igst}}% {{ decimalPoint(total_igst_tax) }}</div>
       </div>
       <div class="col content-list-total" v-if="extractTax.same_state === 1">
         {{ decimalPoint(total_state_tax + total_central_tax) }}</div>
       <div class="col content-list-total" v-else>{{ decimalPoint(total_igst_tax) }}</div>
     </div>
     <div class="row content-list lh hr" v-else></div>
     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">Payable</div>
      <div class="col content-list-total primary">{{ decimalPoint(invoiceTotal.client) }}</div>
     </div>
     <div class="row content-list">
      <div class="col-4 content-list-title no-padding">Requested</div>

      <div class="col content-list-total">{{ decimalPoint(invoiceTotal.transporter) }}</div>
     </div>
     <div class="row content-list" v-if="noteDetails.sumDifference">
      <div class="col-4 content-list-title no-padding">{{(noteDetails.noteType ===1) ? 'CREDIT' : 'DEBIT'}}
              NOTE</div>
      <div class="col content-list-notes"></div>
      <div class="col content-list-total error">{{noteDetails.sumDifference}}</div>
     </div>
    </div>

  </div>


 </div>

 <div class="bottomfixed webnone">
   Note: This is an electronic invoice issued in accordance with the provisions of the Information Technology Act, 2000 (21 of 2000).
   Hence, does not require any signature or digital signature
  </div>


</div>
</template>

<script>
import WalletConstants from '@/constants/wallet';
import { isUgstApplicable } from 'pando-constants';

export default {
  name: 'Footer',
  props: {
    invoice: {
      type: Object,
    },
    extractTax: {
      type: Object,
    },
    customFields: {
      type: Array,
      default: () => [],
    },
    indentsTotal: {
      type: Number,
      default: 0,
    },
    invoiceTotal: {
      type: Object,
      default: () => {},
    },
    total_state_tax: {
      type: Number,
      default: 0,
    },
    total_central_tax: {
      type: Number,
      default: 0,
    },
    total_igst_tax: {
      type: Number,
      default: 0,
    },
    noteDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentRoute: '',
      activeName: '1',
      seen: false,
      penalties: false,

    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
  computed: {
    discountList() {
      let baseTotal = this.indentsTotal;
      return this.invoice.additional_charges.map((discount) => {
        const newObj = {};
        const amount = baseTotal * (discount.percentage / 100);
        newObj.amount = amount;
        if (discount.method === 1) {
          baseTotal += amount;
        }
        if (discount.method === 2) {
          baseTotal -= amount;
        }
        return Object.assign(discount, newObj);
      });
    },

    walletTotal() {
      if (this.invoice.wallet_ids && this.invoice.wallet_ids.length) {
        const wallet = this.invoice.wallet_ids.reduce((acc, wal) => acc + wal.amount, 0);
        console.log(wallet);
        return wallet;
      }
      return 0;
    },

  },
  methods: {
    decimalPoint(value) {
      return (value > 0) ? value.toFixed(2) : 0;
    },
    getType(t) {
      const type = WalletConstants.WalletTypeForExcel;
      return type[t];
    },
  },
};

</script>
<style lang='scss'>
.webnone{
  display:none;
}
.scrolltable{
  height:200px;
  overflow: scroll;
}
</style>
